// UI State
export const POST_PHONE_NUMBER_SUCCESS = 'SMS_AUTH/POST_PHONE_NUMBER_SUCCESS';
export const POST_PHONE_NUMBER_ERROR = 'SMS_AUTH/POST_PHONE_NUMBER_ERROR';
export const VALIDATE_SMS_CODE_SUCCESS = 'SMS_AUTH/VALIDATE_SMS_CODE_SUCCESS';
export const VALIDATE_SMS_CODE_ERROR = 'SMS_AUTH/VALIDATE_SMS_CODE_ERROR';
export const RESET_POST_PHONE_NUMBER_STATE = 'RESET_POST_PHONE_NUMBER_STATE';
export const RESET_VALIDATE_SMS_CODE_STATE = 'RESET_VALIDATE_SMS_CODE_STATE';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const SET_PHONE_NUMBER_SENDING = 'SET_PHONE_NUMBER_SENDING';
export const SET_OTP_SENDING = 'SET_OTP_SENDING';
export const SET_SMS_AUTH_STATE = 'SET_SMS_AUTH_STATE';
export const SET_SMS_CAPTCHA_REFERENCE_TOKEN = 'SET_SMS_CAPTCHA_REFERENCE_TOKEN';
export const SMS_AUTH_STATE_CAPTCHA = 'SMS_AUTH_STATE_CAPTCHA';
export const SMS_AUTH_STATE_CAPTCHA_ERROR = 'SMS_AUTH_STATE_CAPTCHA_ERROR';
export const SMS_AUTH_STATE_CODE = 'SMS_AUTH_STATE_CODE';
export const SMS_AUTH_STATE_CODE_ERROR = 'SMS_AUTH_STATE_CODE_ERROR';
export const SMS_AUTH_STATE_PHONE = 'SMS_AUTH_STATE_PHONE';
export const SMS_AUTH_STATE_PHONE_ERROR = 'SMS_AUTH_STATE_PHONE_ERROR';
export const SMS_CAPTCHA_COMPLETED = 'SMS_CAPTCHA_COMPLETED';
export const SUBMIT_SMS_CAPTCHA_ERROR = 'SUBMIT_SMS_CAPTCHA_ERROR';
export const SUBMIT_SMS_CAPTCHA_SUCCESS = 'SUBMIT_SMS_CAPTCHA_SUCCESS';
export const SMS_AUTH_ERROR_STATES = [
  SMS_AUTH_STATE_CAPTCHA_ERROR,
  SMS_AUTH_STATE_CODE_ERROR,
  SMS_AUTH_STATE_PHONE_ERROR,
];

// ERROR CODES
// Phone Number
export const INVALID_SMS_CAPTCHA_TOKEN_ERROR_CODE = 40096;
export const EMBARGOED_COUNTRY_CODE = 40315;
export const BLACKLISTED_CARRIER = 40316;
export const INVALID_PHONE_NUMBER = 40317;
export const SMS_SEND_COUNT_LIMIT_HIT = 42901;
export const SMS_SEND_RATE_LIMIT_HIT = 42905;

// Phone OTP
export const INCORRECT_ONE_TIME_PASSWORD = 41201;
export const TOO_MANY_INVALID_OTP = 42906;

export const HANDLED_ERROR_MAPPING: {
  [x: number]: string;
} = {
  [EMBARGOED_COUNTRY_CODE]: 'SMSAuth.embargoedCountryCode',
  [BLACKLISTED_CARRIER]: 'SMSAuth.blacklistedCarrier',
  [INVALID_PHONE_NUMBER]: 'SMSAuth.invalidPhone',
  [SMS_SEND_COUNT_LIMIT_HIT]: 'SMSAuth.smsSendCountLimitHit',
  [SMS_SEND_RATE_LIMIT_HIT]: 'SMSAuth.smsSendRateLimitHit',
  [INCORRECT_ONE_TIME_PASSWORD]: 'SMSAuth.incorrectOTP',
  [TOO_MANY_INVALID_OTP]: 'SMSAuth.tooManyInvalidOtp',
};

// Analytics
export const SMS_AUTH_ANALYTICS_EVENT_TRUST_CHALLENGE = 'Trust.Challenge';
export const SMS_AUTH_ANALYTICS_CHALLENGE_TYPE = 'sms_arkose';

// Analytics actions
export const SMS_AUTH_ANALYTICS_ACTION_VIEW = 'view';
export const SMS_AUTH_ANALYTICS_ACTION_ERROR = 'error';
export const SMS_AUTH_ANALYTICS_ACTION_SUBMIT = 'submit';
